import { useMemo, type PropsWithChildren } from 'react'
import VTMN_PLAY_ANTD_THEME from '@vtmn-play/antd'
import { ConfigProvider } from 'antd'
import type { ThemeConfig } from 'antd'
import { buildAntTokenCssValuesMap, SLIDER_TOKENS } from 'components/common/basic-slider/basic-slider.tokens'

export const VitaminPlayAntdProvider = ({ children }: PropsWithChildren) => {
  const theme = useMemo<ThemeConfig>(() => {
    return {
      ...VTMN_PLAY_ANTD_THEME,
      components: {
        ...VTMN_PLAY_ANTD_THEME.components,
        // TODO: remove this Slider overlay (and basic-slider.tokens.ts) once the mapping
        // is shipped in @vtmn-play/antd (in progress as of 2026-09-04).
        Slider: buildAntTokenCssValuesMap(SLIDER_TOKENS)
      }
    }
  }, [])

  return <ConfigProvider theme={theme}>{children}</ConfigProvider>
}
